import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditGroupComponent = loadable(
  () => import("../../components/Group/EditGroup")
);
const EditGroup = () => {
  const { id } = useParams();
  const { refetch } = useGetHook({
    queryKey: [`group`],
    url: `${APIS.LOCATION}${id}/`,
    params: {},
  });
  // const { refetch } = useGetHook({
  // queryKey: [`group`, id],
  // url: APIS.LOCATION,
  // params: { id, group: true },

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["group"],
    navigateURL: "/group",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}${id}/`;
    let formData = {
      ...values,
      parent: null,
      type: "group",
      countries: values.countries?.map((item: any) => item.value),
      group: values?.group?.id ?? values?.group,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Group</span>
      </div>
      <EditGroupComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditGroup;
